import { useEffect, useRef } from 'react'

interface MapLocation {
  label: string; place: string; lat: number; lng: number; date?: string; detail?: string
}
interface MapJourney { asset_name?: string; journey: MapLocation[] }

const COLOURS = ['#059669','#2563eb','#7c3aed','#d97706','#dc2626','#0891b2','#be185d','#166534']
function col(i: number, t: number) { return i === 0 ? COLOURS[0] : i === t - 1 ? COLOURS[7] : COLOURS[(i % 6) + 1] }

export function InlineMap({ data }: { data: MapJourney }) {
  const ref = useRef<HTMLDivElement>(null)
  const map = useRef<any>(null)

  useEffect(() => {
    const geo = data.journey.filter(l => l.lat && l.lng)
    if (!geo.length || !ref.current) return
    if (!document.querySelector('link[href*="leaflet"]')) {
      const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'; document.head.appendChild(l)
    }
    const loadL = (): Promise<any> => {
      if ((window as any).L) return Promise.resolve((window as any).L)
      return new Promise(r => {
        if (document.querySelector('script[src*="leaflet"]')) { const c = setInterval(() => { if ((window as any).L) { clearInterval(c); r((window as any).L) } }, 50); return }
        const s = document.createElement('script'); s.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'; s.onload = () => r((window as any).L); document.head.appendChild(s)
      })
    }
    loadL().then(L => {
      if (!ref.current) return
      if (map.current) { map.current.remove(); map.current = null }
      const m = L.map(ref.current, { scrollWheelZoom: false }); map.current = m
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OSM', maxZoom: 18 }).addTo(m)
      const coords: [number,number][] = []
      geo.forEach((loc, i) => {
        const c = col(i, geo.length); const coord: [number,number] = [loc.lat, loc.lng]; coords.push(coord)
        L.marker(coord, { icon: L.divIcon({ html: `<div style="background:${c};color:white;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:10px;border:2px solid white;box-shadow:0 2px 4px rgba(0,0,0,0.3)">${i+1}</div>`, className: '', iconSize: [22,22], iconAnchor: [11,11] }) }).addTo(m)
          .bindPopup(`<b style="color:${c}">${loc.label}</b><br/>${loc.place}${loc.date ? '<br/><small>'+loc.date+'</small>' : ''}`)
      })
      if (coords.length > 1) L.polyline(coords, { color: '#3b82f6', weight: 2, opacity: 0.7, dashArray: '6,6' }).addTo(m)
      m.fitBounds(L.latLngBounds(coords), { padding: [25,25], maxZoom: 6 })
    })
    return () => { if (map.current) { map.current.remove(); map.current = null } }
  }, [data])

  return (
    <div className="my-2 rounded-lg overflow-hidden border border-gray-200">
      {data.asset_name && <div className="bg-gray-50 px-2 py-1 text-[10px] font-semibold text-gray-500 border-b">{data.asset_name}</div>}
      <div ref={ref} style={{ height: 220 }} />
      <div className="px-2 py-1.5 bg-gray-50 border-t space-y-0.5">
        {data.journey.map((loc, i) => (
          <div key={i} className="flex items-center gap-1.5 text-[10px]">
            <span className="w-3.5 h-3.5 rounded-full text-white flex items-center justify-center font-bold shrink-0" style={{ background: col(i, data.journey.length), fontSize: 8 }}>{i+1}</span>
            <span className="font-medium" style={{ color: col(i, data.journey.length) }}>{loc.label}</span>
            <span className="text-gray-400 truncate">{loc.place}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
